import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Grid } from '@mui/material';

const ChangePasswordDialog = ({ open, onClose, onSubmit }) => {
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');

    React.useEffect(() => {
        setOldPassword('');
        setNewPassword('');
    }, [open]);

    const handleSubmit = () => {
        onSubmit(oldPassword, newPassword);
        onClose();
    };

    const isValid = oldPassword.length > 0 && newPassword.length >= 8;

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Cambia la tua password</DialogTitle>
            <DialogContent>
                <Grid container spacing={2} sx={{ minWidth: '350px', pt: 1 }}>
                    <Grid item xs={12}>
                        <TextField
                            autoFocus
                            margin="dense"
                            label="Password attuale"
                            type="password"
                            fullWidth
                            variant="outlined"
                            value={oldPassword}
                            onChange={(e) => setOldPassword(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            margin="dense"
                            label="Nuova password (min 8 caratteri)"
                            type="password"
                            fullWidth
                            variant="outlined"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleSubmit} color="primary" disabled={!isValid}>
                    OK
                </Button>
                <Button onClick={onClose} color="secondary">
                    Annulla
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ChangePasswordDialog;
